export const LABEL_INPUT_REGEX = /^[A-Za-z0-9-_|.]{0,30}$/;